module.exports = __webpack_public_path__ + "img/logo-light.409af706.png";